import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function accountHolderNameValidator(): ValidatorFn {
    // Compile regex once outside the return function to avoid recompilation on each validation
    const VALID_NAME_PATTERN = /^[A-Za-z0-9.'-]+( [A-Za-z0-9.'-]+)*$/;

    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        // Early return for empty values
        if (!value || value === "") return null;

        // Combined check: if value has extra whitespace or fails the regex pattern
        if (value !== value.trim() || !VALID_NAME_PATTERN.test(value)) {
            return { invalidAccountHolderName: true };
        }

        return null;
    };
}
